// hooks/useDhis2Data.js
import { useDataQuery } from '@dhis2/app-runtime'

// Query to get available indicators
const INDICATORS_QUERY = {
  indicators: {
    resource: 'indicators',
    params: {
      fields: 'id,name,code',
      paging: false
    }
  }
}

const DATA_ELEMENTS_QUERY = {
  dataElements: {
    resource: 'dataElements',
    params: {
      fields: 'id,name,code,valueType',
      paging: false
    }
  }
}

export const useDataElements = () => {
  return useDataQuery(DATA_ELEMENTS_QUERY)
}

// Query to get organisation unit structure
const ORG_UNIT_QUERY = {
  orgUnit: {
    resource: 'organisationUnits',
    id: ({ id }) => id,
    params: {
      fields: 'id,name,level,children[id,name,level]'
    }
  }
}

// Query for analytics data
const ANALYTICS_QUERY = {
  analytics: {
    resource: 'analytics',
    params: ({ dimension, filter }) => ({
      dimension: dimension,
      filter: filter,
      skipMeta: true,
      skipData: false,
      hierarchyMeta: true
    })
  }
}

export const useIndicators = () => {
  return useDataQuery(INDICATORS_QUERY)
}

export const useOrgUnit = (orgUnitId) => {
  return useDataQuery(ORG_UNIT_QUERY, {
    variables: { id: orgUnitId },
    skip: !orgUnitId
  })
}

export const useAnalyticsData = (orgUnitId, indicatorIds, period = 'LAST_12_MONTHS') => {
  const dimension = `dx:${indicatorIds.join(';')}&dimension=ou:${orgUnitId}&dimension=pe:${period}`
  
  return useDataQuery(ANALYTICS_QUERY, {
    variables: {
      dimension: dimension,
      filter: ''
    }
  })
}
